export enum Feature {
  adapted = 'adapted',
  clickable = 'clickable',
  badge = 'badge',
  dropdown = 'dropdown',
  selectAll = 'selectAll',
  allowEmpty = 'allowEmpty',
  search = 'search',
  smarty = 'smarty',
  reload = 'reload',
  multiplex = 'multiplex',
  today = 'today',
  marks = 'marks',
  multiline = 'multiline',
  pulse = 'pulse'
}
